
import { IDataProviderRequest } from "@/interfaces/data-provider";
import { useCatalog, useMetadataCatalog } from "@/store";
import { defineComponent } from "@vue/composition-api";
import { zipObject } from "lodash";
import { mapState } from "pinia";
import config from "@/util/constants";

export default defineComponent({
  name: "AddUpdateLog",
  data: () => ({
    updateTypeTbl: new Array<any>(),
    dpRequest: {} as IDataProviderRequest,
    fields: new Array<string>(),
    items: new Array<any>(),

    // updateTypeTblN: "update_type",
    // updateLogTblN: "v_update_log",
    // tblPath: "/data_mgmt/all/System/",

    updateTypeTblN: config.metaCat.v_update_type,
    updateLogTblN: config.metaCat.v_update_log,
    tblPath: "/meta_cat/",

    dataCatEntry: {
      data_cat_id: { val: null as any, type: Number, isRequired: true },
      update_type_id: { val: null, type: Number, isRequired: true },
      end_update_date: { val: null, type: String, isRequired: true },
      update_comment: { val: null as any, type: String, isRequired: true },
      update_status_id: { val: null as any, type: Number, isRequired: true },
      update_due_date: { val: null, type: String, isRequired: true },
      new_version_num: { val: null as any, type: String, isRequired: true },
    },
  }),
  computed: {
    ...mapState(useCatalog, ["tableMeta", "tableData"]),
    ...mapState(useMetadataCatalog, ["updateLogUri", "selectedDataCatId"]),
  },
  watch: {},
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.dataCatEntry.update_status_id.val = 2;
      this.dataCatEntry.update_comment.val = "New Dataset";
      this.dataCatEntry.new_version_num.val = "1, 0, 0";
      this.dataCatEntry.data_cat_id.val = this.selectedDataCatId;
      await this.catalogChange(this.updateTypeTblN);
    },
    async loadData(tableName: string, columns: Array<string>) {
      await useCatalog()
        .getTableData({
          catalogUri: this.tblPath + tableName,
          request: this.dpRequest,
        })
        .then(() => this.setTableData(tableName, columns));
    },
    setTableData(tableName: string, columns: Array<string>) {
      if (this.tableData?.rows.length) {
        switch (tableName) {
          case this.updateTypeTblN:
            this.updateTypeTbl = this.tableData?.rows.map((r: unknown[]) =>
              zipObject(columns, r)
            );
            break;
          default:
            this.showMessage(
              "danger",
              "Couldn't find the matching table name!! - " + tableName
            );
            break;
        }
      }
    },
    async catalogChange(tableName: string) {
      // Retrieve table meta
      await useCatalog()
        .getTableMeta({
          catalogUri: this.tblPath + tableName,
          request: {},
        })
        .then(() => {
          this.setTableColumns(tableName);
        });
    },
    setTableColumns(tableName: string) {
      if (this.tableMeta?.columns.length) {
        let columns = this.tableMeta.columns.map(
          (c: { columnName: string }) => c.columnName
        );
        this.loadData(tableName, columns);
      }
    },
    async updateDB(param: string) {
      const methodN = "updateDB";
      const requestFrom = "update_log";
      const nextPage = "data_desc_cat";
      const catUri = this.tblPath + this.updateLogTblN;

      this.$emit(
        methodN,
        requestFrom,
        param,
        this.dataCatEntry,
        nextPage,
        catUri,
        this.updateLogUri
      );
    },
    showMessage(type: string, msg: string) {
      this.$root.$emit("showAlert", 4, type, msg);
    },
  },
});
